import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls"
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const CompetitionSportType = () => {

    const [compSportTypeList, setCompSportTypeList] = useState<any[]>([]);
    const [competitionSportsTypeId, setCompetitionSportsTypeId] = useState("");
    const [compSportTypeName, setCompSportTypeName] = useState("");
    const [compSprtTypStatus, setCompSprtTypStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCompetitionSportsType() {
            setIsLoading(true);
            const compSprtTypeResponse = await func.competitionSportType(null);
            setCompSportTypeList(Array.isArray(compSprtTypeResponse) ? compSprtTypeResponse : [])
            setIsLoading(false);
        }
        fetchCompetitionSportsType();
    }, [])

    const filteredData = compSportTypeList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compSportTypeNameRender = (rowData) => {
        return <span>{rowData.SportTypeName}</span>
    };

    const compSportStatus = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    }

    function newCompetitionSportType() {
        setOpenModal(true);
        setIsEdit(false)
        setCompSportTypeName("");
    }
    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCompSportType(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const compsprtTypId = rowData.competitionSportsTypeId;
        return (
            <Link to="#" onClick={() => deleteCompSportType(compsprtTypId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompSportType(rowData: { competitionSportsTypeId: any; }) {
        const compsprttypid = rowData.competitionSportsTypeId;
        setOpenModal(true)
        setIsEdit(true)
        const getDetails = await func.competitionSportType(compsprttypid);
        setCompetitionSportsTypeId(getDetails.competitionSportsTypeId);
        setCompSportTypeName(getDetails.SportTypeName);
        setCompSprtTypStatus(getDetails.status);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitionSportType();
            } else {
                const formData = new FormData();
                formData.append("name", compSportTypeName);
                const createSportType = api.competitionSportType;
                fetch(createSportType, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateCompetitionSportType() {
        const formData = new FormData();
        formData.append("name", compSportTypeName);
        formData.append("status", compSprtTypStatus);

        const updateCompSprtType = api.competitionSportType + "/" + competitionSportsTypeId;
        fetch(updateCompSprtType, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompSportType(compid: string) {
        const delteCompSprtTyp = api.competitionSportType + "/" + competitionSportsTypeId + "/0";
        fetch(delteCompSprtTyp, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Categories</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetitionSportType() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Category">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="SportTypeName"
                                                header="Category"
                                                body={compSportTypeNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={compSportStatus}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="md"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Category</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Category</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="compSportName"
                                        placeholder="Enter Category"
                                        required
                                        value={compSportTypeName}
                                        onChange={(e) => setCompSportTypeName(e.target.value)}
                                    />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={compSprtTypStatus === '1'}
                                                    id="status"
                                                    onChange={(e) => {
                                                        setCompSprtTypStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    )
};

export default CompetitionSportType;